<template>
  <div class="accountInfoNew">
    <div class="account-container">
      <p class="account-title">{{ $t('account_information') }}</p>

      <div class="input_box">
        <p class="box-label">{{ $t("firstName") }}</p>
        <el-input
          :class="[this.dataFormError.firstName ? 'el-input-error' : 'el-input']"
          v-model="dataForm.firstName"
          :placeholder="[this.dataFormError.firstName ? this.dataFormError.firstName : $t('firstName')]"
        ></el-input>
      </div>

      <div class="input_box">
        <p class="box-label">{{ $t("lastName") }}</p>
        <el-input
          :class="[this.dataFormError.lastName ? 'el-input-error' : 'el-input']"
          v-model="dataForm.lastName"
          :placeholder="[this.dataFormError.lastName ? this.dataFormError.lastName : $t('lastName')]"
        ></el-input>
      </div>

      <div class="input_box phone_box">
        <p class="box-label">{{ $t('phone_number_optional') }}</p>
        <el-input
          :class="[this.dataFormError.phone ? 'el-input-error' : 'el-input']"
          v-model="dataForm.phone"
          :placeholder="[this.dataFormError.phone ? this.dataFormError.phone : $t('phone')]"
        >
          <template slot="append">
            <div
              v-if="isNewPhone"
              @click.stop="getPhoneActiveCodeByPhone"
              :style="isShowSendCodeTime ? 'opacity: 0.6' : ''">
              {{ $t('send_code') }}
              <span v-if="isShowSendCodeTime">({{ sendCodeTime }})</span>
            </div>
          </template>
        </el-input>
        <span style="height: 15px; color: rgb(255, 0, 0);">{{ this.dataFormError.phone }}</span>
      </div>
      <div v-if="isNewPhone" class="input_box input_box_top">
        <p class="box-label">{{ $t("verification_code") }}</p>
        <el-input
          :class="[this.dataFormError.code ? 'el-input-error' : 'el-input']"
          v-model="dataForm.code"
          :placeholder="[this.dataFormError.code ? this.dataFormError.code : $t('enter_code')]"
        ></el-input>
        <span style="height: 15px; color: rgb(255, 0, 0);">{{ this.dataFormError.code }}</span>
      </div>

      <div class="input_box">
        <p class="box-label">{{ $t('email') }}</p>
        <!-- <el-input
          :class="[false ? 'el-input-error' : 'el-input']"
          v-model="dataForm.email"
          placeholder="Email"
        ></el-input> -->
        <div class="box-container">
          <p class="box-content">{{ dataForm.email }}</p>
          <div v-if="!userDetails.verify_email" class="box-button" @click="openVerifyModal">
            {{ $t('verify') }}
          </div>
          <div v-else class="box-button-verified">
            {{ $t('verified') }}
          </div>
        </div>
      </div>

      <div class="input_box">
        <p class="box-label">{{ $t('password') }}</p>
        <!-- <el-input
          :class="[false ? 'el-input-error' : 'el-input']"
          v-model="dataForm.password"
          placeholder="Password"
        ></el-input> -->
        <div class="box-container">
          <p class="box-content">***********</p>
          <div class="box-button" @click="changePasswordModalVisibility=true">
            {{ $t('change') }}
          </div>
        </div>
      </div>

      <div class="account-info-button-container">
        <button class="account-info-button" @click="confirmAccountInfo">{{ $t('done') }}</button>
      </div>

    </div>

    <transition name="modal" v-if="changePasswordModalVisibility">
      <div class="modal-mask" @click="closeChangePasswordModal">
        <div class="modal-wrapper">
          <div class="modal-container10" @click.stop>
            <div class="close-modal">
              <img
                @click="closeChangePasswordModal"
                src="../../assets/img/closemodal.png"
                alt=""
              />
            </div>
            <p class="change-password-title">{{ $t('change_password') }}</p>
            <p class="change-password-title-error">{{ this.changePasswordError.server }}</p>
            <div class="input_box_pw">
              <span class="box-label" style="margin-left: 20px">{{ $t("currentPassword") }}</span>
              <el-input
                :class="[this.changePasswordError.currentPassword ? 'el-input-error' : 'el-input']"
                v-model="changePasswordForm.currentPassword"
                :placeholder="[this.changePasswordError.currentPassword ? this.changePasswordError.currentPassword : $t('currentPassword')]"
                type="password"
              ></el-input>
            </div>
            <div class="input_box_pw">
              <span class="box-label" style="margin-left: 20px">{{ $t("newPassword") }}</span>
              <el-input
                :class="[this.changePasswordError.newPassword ? 'el-input-error' : 'el-input']"
                v-model="changePasswordForm.newPassword"
                :placeholder="[this.changePasswordError.newPassword ? this.changePasswordError.newPassword : $t('newPassword')]"
                type="password"
              ></el-input>
            </div>
            <div class="input_box_pw">
              <span class="box-label" style="margin-left: 20px">{{ $t("reenterNewPassword") }}</span>
              <el-input
                :class="[this.changePasswordError.newPasswordReenter ? 'el-input-error' : 'el-input']"
                v-model="changePasswordForm.newPasswordReenter"
                :placeholder="[this.changePasswordError.newPasswordReenter ? this.changePasswordError.newPasswordReenter : $t('reenterNewPassword')]"
                type="password"
                @input="reenterCheck"
              ></el-input>
            </div>
            <div class="change-password-button-container">
              <button class="change-password-button" @click="confirmChangePassword">Confirm</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal" v-if="verifyEmailModalVisibility">
      <div class="modal-mask" @click="closeVerifyModal">
        <div class="modal-wrapper">
          <div class="modal-container11" @click.stop>
            <div class="close-modal">
              <img
                @click="closeVerifyModal"
                src="../../assets/img/closemodal.png"
                alt=""
              />
            </div>
            <p class="verify-email-title">{{ $t('verify_email') }}</p>
            <p class="verify-email-title-error">{{ this.verifyEmailError }}</p>
            <p class="verify-email-info">{{ $t('verify_email_info') }}</p>
            <div class="input_box_email">
              <span class="box-label" style="margin-left: 20px">{{ $t("verifyCode") }}</span>
              <el-input
                :class="[this.verifyEmailError ? 'el-input-error' : 'el-input']"
                v-model="verifyEmailCode"
                :placeholder="$t('verifyCode')"
                type="password"
              ></el-input>
            </div>
            <div class="verify-email-button-container">
              <button class="verify-email-button" @click="resendVerifyCode">{{ $t('resend') }}</button>
              <button class="verify-email-button" @click="confirmVerifyCode">{{ $t('confirm') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>


<script>
import {mapActions, mapState, mapMutations} from "vuex";
const defaultCodeTime = 60

export default {
  name: "AccountInfoNew",
  data() {
    return {
      changePasswordModalVisibility: false,

      changePasswordForm: {
        currentPassword: "",
        newPassword: "",
        newPasswordReenter: "",
      },
      changePasswordError: {
        currentPassword: "",
        newPassword: "",
        newPasswordReenter: "",
        server: "",
      },

      verifyEmailModalVisibility: false,
      verifyEmailCode: "",
      verifyEmailError: "",

      dataForm: {
        firstName: "",
        lastName: "",
        email: "",
        phonePre: "1",
        phone: "",
        // 用户收到的短信验证码
        code: "",
        // 调获取短信验证码接口返回的token
        token: "",
      },
      dataFormError: {
        firstName: "",
        lastName: "",
        email: "",
        // phonePre: "1",
        phone: "",
        code: ""
      },
      sendCodeTime: 0,
      timeoutId: ''
    };
  },
  methods: {
    ...mapActions("profile", [
      "updateAccountInfo",
      "sendVerifyEmail",
      "checkVerifyEmail",
      "fetchSubscribeEmail",
      "postSubscribeEmail",
      "putUnsubscribeEmail",
      "fetchProductReviews",
      "submitProductReviews",
    ]),
    ...mapMutations("navbar", [
      "toggleLoginModalVisibility",
      "toggleRegisterModalVisibility",
    ]),
    ...mapMutations("auth", [
      "updateToken",
    ]),
    ...mapActions('auth', ['changePassword', 'fetchCustomerInformation', 'getPhoneActiveCode', 'checkUsername']),
    initializeData() {
      this.dataForm = {
        firstName: this.userDetails.FirstName,
        lastName: this.userDetails.LastName,
        email: this.userDetails.email,
        phonePre: "1",
        phone: this.userDetails.phone,
        code: "",
        token: "",
      };
    },
    // CHANGE PW START
    resetChangePassword() {
      this.changePasswordForm = {
        currentPassword: "",
        newPassword: "",
        newPasswordReenter: "",
      };
      this.changePasswordError = {
        currentPassword: "",
        newPassword: "",
        newPasswordReenter: "",
        server: "",
      };
    },
    // changePasswordSuccess() {
    // this.$alert('You have successfully changed password', 'Success', {
    //     confirmButtonText: 'OK',
    //     type: 'success',
    //     center: true
    // }).then(() => {
    //     this.changePasswordModalVisibility = false;
    //     this.resetChangePassword();
    // }).catch(() => {});
    // },
    changePasswordSuccess() {
      this.$notify({
        type: 'success',
        title: 'Password Changed',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 3000
      });
    },
    closeChangePasswordModal() {
      this.resetChangePassword();
      this.changePasswordModalVisibility = false;
    },
    reenterCheck() {
      if (this.changePasswordForm.newPassword !== this.changePasswordForm.newPasswordReenter) {
        this.changePasswordError.newPasswordReenter = this.$t("doesNotMatch");
      } else {
        this.changePasswordError.newPasswordReenter = "";
      }
    },
    validateChangePassword() {
      if (!this.changePasswordForm.currentPassword) {
        this.changePasswordError.currentPassword = this.$t("required");
      } else {
        this.changePasswordError.currentPassword = "";
      }
      if (!this.changePasswordForm.newPassword) {
        this.changePasswordError.newPassword = this.$t("required");
      } else {
        this.changePasswordError.newPassword = "";
      }
      if (!this.changePasswordForm.newPasswordReenter) {
        this.changePasswordError.newPasswordReenter = this.$t("required");
      } else {
        this.changePasswordError.newPasswordReenter = "";
      }
    },
    confirmChangePassword() {
      this.validateChangePassword();
      if (!this.changePasswordError.currentPassword && !this.changePasswordError.newPassword && !this.changePasswordError.newPasswordReenter) {

        const data = {
          new_password: this.changePasswordForm.newPassword,
          old_password: this.changePasswordForm.currentPassword,
        }
        this.changePassword(data)
          .then(res => {
            this.changePasswordSuccess();
            this.resetChangePassword();
            this.changePasswordModalVisibility = false;
          })
          .catch(err => {
            if (err.response.data === 'New password cannot be the same with the last password') {
              this.changePasswordError.server = this.$t("samePassError");
            } else {
              this.changePasswordError.server = this.$t("wrongPassword");
            }
          })
      }
    },
    // CHANGE PW END
    // CHANGE OAO START
    // confirmAccountSuccess() {
    // this.$alert('Account information has been updated', 'Success', {
    //     confirmButtonText: 'OK',
    //     type: 'success',
    //     center: true
    // }).then(() => {
    // }).catch(() => {});
    // },
    confirmAccountSuccess() {
      this.$notify({
        type: 'success',
        title: 'Account Info Updated',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 3000
      });
    },
    confirmAccountFailed() {
      this.$notify({
        type: 'error',
        title: 'Error',
        message: 'Failed to update account info, please try again later.',
        position: 'bottom-right',
        duration: 5000
      });
    },
    validPhoneNumber: function (phone) {
      // const phoneNumberRegEx = /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/;
      const phoneNumberRegEx = /^\d{10}$/;
      return phoneNumberRegEx.test(phone);
    },
    validName: function (name) {
      const nameRegEx = /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/;
      return nameRegEx.test(name);
    },
    resetAccountInfo() {
      this.dataForm = {
        firstName: this.userDetails.FirstName,
        lastName: this.userDetails.LastName,
        email: this.userDetails.email,
        phonePre: "1",
        phone: this.userDetails.phone,
        code: "",
        token: "",
      };
      this.resetErrors()
    },
    async validateAccountInfo() {
      this.resetErrors()
      if (this.isNewPhone && !this.validPhoneNumber(this.dataForm.phone)) {
        this.dataFormError.phone = this.$t("phoneValidRequired");
      } else if (this.isNewPhone) {
        const isPhoneErr = await this.checkUsername({ username: this.dataForm.phone });
        isPhoneErr && (this.dataFormError.phone = this.$t("phoneTaken"))
      }
      if (this.isNewPhone && !this.dataForm.code) {
        this.dataFormError.code = this.$t('codeRequired')
      }
      if (!this.dataForm.firstName) {
        this.dataFormError.firstName = this.$t("required");
      } else if (this.dataForm.firstName && !this.validName(this.dataForm.firstName)) {
        this.dataFormError.firstName = this.$t("nameValidRequired");
      }
      if (!this.dataForm.lastName) {
        this.dataFormError.lastName = this.$t("required");
      } else if (this.dataForm.lastName && !this.validName(this.dataForm.lastName)) {
        this.dataFormError.lastName = this.$t("nameValidRequired");
      }
    },
   async confirmAccountInfo() {
      await this.validateAccountInfo();
      if (!this.dataFormError.phone && !this.dataFormError.code && !this.dataFormError.firstName && !this.dataFormError.lastName) {

        let output = {
          FirstName: this.dataForm.firstName,
          LastName: this.dataForm.lastName,
          phone: this.dataForm.phone,
          username: this.dataForm.phone,
          code: this.dataForm.code,
          token: this.dataForm.token
        }
        this.updateAccountInfo(output)
          .then(res => {
            // console.log("token res", res.data);
            this.confirmAccountSuccess();
            localStorage.setItem('token', res.data);
            this.updateToken(res.data);
            this.$store.dispatch('auth/fetchCustomerInformation');
            this.resetAccountInfo();
          }).catch(err => {
            this.confirmAccountFailed();
          });
      }
    },
    // CHANGE OAO END
    // VERIFY EMAIL START
    verifySuccess() {
      this.$notify({
        type: 'success',
        title: 'Email is Verified',
        // message: '分享链接给好友',
        position: 'bottom-right',
        duration: 3000
      });
    },
    resendSuccess() {
      this.$notify({
        type: 'success',
        title: 'New verify code sent',
        message: 'Please check your email',
        position: 'bottom-right',
        duration: 5000
      });
    },
    resendFailed() {
      this.$notify({
        type: 'error',
        title: 'Failed to send verify code',
        message: 'Please try again later.',
        position: 'bottom-right',
        duration: 5000
      });
    },
    openVerifyModal() {
      this.sendVerifyEmail()
        .then(res => {
        }).catch(err => {
      });
      this.verifyEmailModalVisibility = true;
    },
    closeVerifyModal() {
      this.verifyEmailModalVisibility = false;
      this.verifyEmailCode = "";
      this.verifyEmailError = "";
    },
    confirmVerifyCode() {
      if (this.verifyEmailCode) {
        console.log("confirmVerifyCode", this.verifyEmailCode);
        this.checkVerifyEmail({code: this.verifyEmailCode})
          .then(res => {
            this.verifySuccess();
            this.closeVerifyModal();
            this.$store.dispatch('auth/fetchCustomerInformation');
          }).catch(err => {
          this.verifyEmailError = this.$t("wrongVerifyCode");
        });
      }
    },
    resendVerifyCode() {
      this.sendVerifyEmail()
        .then(res => {
          this.resendSuccess();
        }).catch(err => {
        this.resendFailed();
      });
    },
    // VERIFY EMAIL END
    resetErrors() {
      Object.keys(this.dataFormError).forEach(key => {
        this.dataFormError[key] = ''
      })
    },
    async getPhoneActiveCodeByPhone() {
      if (this.isShowSendCodeTime) return
      this.dataFormError.phone = ''
      const phone = this.dataForm.phone
      if (!this.validPhoneNumber(phone)) {
        return this.dataFormError.phone = this.$t("phoneValidRequired");
      }
      const {type, data} = await this.getPhoneActiveCode(phone)
      switch (type) {
        case 0:
          this.dataForm.token = data
          this.sendCodeTimeChangeAfter()
          break
        case 1:
          this.dataFormError.phone = this.$t("phoneTaken")
          break
        case 2:
          this.dataFormError.phone = this.$t("tryAgain")
          break
      }
    },
    sendCodeTimeChange() {
      this.sendCodeTime--
      if (this.sendCodeTime <= 0) {
        return
      }
      this.timeoutId = setTimeout(this.sendCodeTimeChange, 1000)
    },
    sendCodeTimeChangeAfter() {
      clearTimeout(this.timeoutId)
      this.sendCodeTime = defaultCodeTime
      this.sendCodeTimeChange()
    }
  },
  mounted() {
    // console.log("MOUNTED");
    this.$store.dispatch('auth/fetchCustomerInformation');
    this.initializeData();
  },
  watch: {
    $route(to, from) {
      this.resetAccountInfo();
    },
    userDetails: function (newVal, oldVal) {
      // console.log("userDetails", newVal);
      this.initializeData();
    },
  },
  computed: {
    ...mapState({
      userDetails: state => state.auth.userDetails,
    }),
    isShowSendCodeTime() {
      return this.sendCodeTime > 0
    },
    isNewPhone() {
      const userPhone = this.userDetails.phone
      const formPhone = this.dataForm.phone
      return !userPhone || userPhone !== formPhone
    }
  },
};
</script>

<style scoped lang="less">
@import "../../assets/css/public";
@import "../../assets/css/accountInfoNew";
</style>



// WEBPACK FOOTER //
// src/view/Profile/accountInfoNew.vue